import { deepMerge } from "grommet/utils";
import { hpe } from "grommet-theme-hpe";

// v8 cards have no shadow and match the white page in light mode; give them an edge there only
export const appTheme = deepMerge(hpe, {
    global: {
        colors: {
            "card-border": { light: "#d4d8db", dark: "transparent" },
            // HPE tokens only define 8 categorical colours; these extend the palette for larger charts
            "graph-8": { light: "#a87b00", dark: "#f2c14e" },
            "graph-9": { light: "#5f7a1f", dark: "#a8d06a" },
        },
        elevation: {
            light: { card: "0 2px 4px rgba(0, 0, 0, 0.12)" },
            dark: { card: "none" },
        },
    },
    card: {
        container: {
            elevation: "card",
            border: { color: "card-border", size: "xsmall" },
        },
    },
});
